// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"415":"73dd7353fb1cade7","888":"e728325462b362fe"}[chunkId] + ".css";
};